import { Box, Grid, Skeleton } from '@mui/material';
import { Card, CardContent, Typography, ToggleButtonGroup, ToggleButton } from '@mui/material'
import "./style.css"
import { HTMLAttributes, memo, useEffect, useState } from 'react';
import { ComponentProps } from './types';
import { useAppDispatch, useAppSelector } from '../../store/store';
import { getEnvironmentRiskScoreData } from '../../store/thunk/mainDashboardThunk';
import moment from 'moment';
import ReactSpeedometer from "react-d3-speedometer"
import getFormattedDate, { DateFormat } from '../common/DateFormat';

const EnvironmentalRiskScore = ({ id, index, pin, pinComponentHandler, selectedValueFacility, facilityIds, locationIds, currentTenant, ...rest }: ComponentProps) => {
    const dispatch = useAppDispatch();
    const environmentRiskScore = useAppSelector(store => store?.mainDashboard.environmentRiskScore);
    const locationLoader = useAppSelector(store => store?.locationSlice?.loading);
    const tenantLoader = useAppSelector(store => store?.tenantSlice?.loading);
    const [loader, setLoader] = useState(true);
    useEffect(() => {
        setLoader(environmentRiskScore?.loading || locationLoader || tenantLoader);
    }, [environmentRiskScore?.loading, locationLoader, tenantLoader]);
    const [filterType, setFilterType] = useState("29");
    const [filterDate, setFilterDate] = useState(() => {
        const startDate = moment().subtract(29, 'days').startOf('day');
        const endDate = moment();
        // const endDate = moment().endOf('days');
        return {
            startDate,
            endDate,
            prevStartDate: moment(startDate).subtract(30, 'days'),
            prevEndDate: moment(startDate).subtract(1, 'days').endOf("day"),
        }
    });
    const { userData } = useAppSelector(store => store?.authReducer);
    if (userData?.timezone) {
        moment.tz.setDefault(userData?.timezone);
    } else {
        moment.tz.setDefault(moment.tz.guess());
    }
    useEffect(() => {

        const facilityKey = facilityIds?.replace("all,", "");
        if (/* currentTenant?.tenantCode &&  */(facilityKey || locationIds /* || userData?.group === 'admin' */)) {
            console.log("facilityIds ", facilityIds);
            dispatch(getEnvironmentRiskScoreData({
                tenantCode: currentTenant?.tenantCode as string,
                facilityKey: facilityKey,
                locationId: locationIds,
                startDate: moment(filterDate?.startDate)?.utc()?.valueOf(),
                endDate: moment(filterDate?.endDate).utc()?.valueOf(),
                prevStartDate: moment(filterDate?.prevStartDate)?.utc()?.valueOf(),
                prevEndDate: moment(filterDate?.prevEndDate)?.utc()?.valueOf(),
                riskStartDate: moment().startOf('day')?.utc()?.valueOf(),
                riskEndDate: moment().utc()?.valueOf(),
            }));
        }
    }, [/* currentTenant?.tenantCode,  */ facilityIds, locationIds, filterDate/* , userData?.group */]);

    const filterHandler = (startDate: moment.Moment, endDate: moment.Moment, filterType: string) => {
        setFilterType(filterType);
        setFilterDate({
            startDate: startDate,
            endDate: endDate,
            prevStartDate: moment(startDate).subtract(parseInt(filterType) + 1, 'days'),
            prevEndDate: moment(startDate).subtract(1, 'days').endOf("day"),
        });
    }

    return (
        <>
            <Card sx={{
                borderRadius: "3px !important",
                border: "none",
                backgroundColor: "#fff !important",
                boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.1) !important",
                height: "100%",
                width: "100%"
            }}>
                <Box onClick={() => pinComponentHandler(id)} sx={{ position: 'absolute', display: 'flex', justifyContent: 'flex-end', right: 10, top: "15px", cursor: "pointer" }}>
                    {pin ? <img src="./assets/images/pin-filled.png" alt="pin" width={15} /> : <img src="./assets/images/pin-outline.png" alt="pin" width={15} />}
                </Box>
                <CardContent sx={{ height: 450 }}>
                    <Box className="title" {...(pin ? {} : rest)} sx={{ marginBottom: 2, ":hover": (pin ? {} : { backgroundColor: "#f4f4f4", borderRadius: "10px", cursor: "grab", }) }}>
                        <Typography variant="h6" sx={{ fontWeight: 'bolder', pl: 1 }} gutterBottom>Environment Threshold Score</Typography>
                    </Box>
                    <ToggleButtonGroup
                        value="30"
                        exclusive
                        size="small"
                        sx={{ mb: "1.5rem", display: "flex", gap: 2 }}
                    >
                        <ToggleButton
                            disabled={loader || filterType === "29"}
                            value="29"
                            className={`filter-button ${filterType === "29" && "filter-button-color-black"}`}
                            onClick={(e, value) => {
                                const startDate = moment().subtract(value, "days").startOf("day");
                                const endDate = moment();
                                filterHandler(startDate, endDate, value);
                            }}
                            sx={{
                                textTransform: "none",
                                transition: "background-color 0.3s ease, color 0.3s ease",
                                "&:hover": {
                                    backgroundColor: filterType === "29" ? "primary.dark" : "grey.300",
                                    // Optionally change text color on hover:
                                    color: filterType === "29" ? "#fff" : "inherit",
                                },
                            }}
                        >
                            30 days
                        </ToggleButton>
                        <ToggleButton
                            disabled={loader || filterType === "59"}
                            value="59"
                            className={`filter-button ${filterType === "59" && "filter-button-color-black"}`}
                            onClick={(e, value) => {
                                const startDate = moment().subtract(value, "days").startOf("day");
                                // const endDate = moment().endOf("day");
                                const endDate = moment();
                                filterHandler(startDate, endDate, value);
                            }}
                            sx={{
                                textTransform: "none",
                                transition: "background-color 0.3s ease, color 0.3s ease",
                                "&:hover": {
                                    backgroundColor: filterType === "59" ? "primary.dark" : "grey.300",
                                    color: filterType === "59" ? "#fff" : "inherit",
                                },
                            }}
                        >
                            60 days
                        </ToggleButton>
                        <ToggleButton
                            disabled={loader || filterType === "89"}
                            value="89"
                            className={`filter-button ${filterType === "89" && "filter-button-color-black"}`}
                            onClick={(e, value) => {
                                const startDate = moment().subtract(value, "days").startOf("day");
                                const endDate = moment();
                                filterHandler(startDate, endDate, value);
                            }}
                            sx={{
                                textTransform: "none",
                                transition: "background-color 0.3s ease, color 0.3s ease",
                                "&:hover": {
                                    backgroundColor: filterType === "89" ? "primary.dark" : "grey.300",
                                    color: filterType === "89" ? "#fff" : "inherit",
                                },
                            }}
                        >
                            90 days
                        </ToggleButton>
                    </ToggleButtonGroup>

                    <Box sx={{ my: 3 }}>
                        {getFormattedDate(filterDate.startDate, DateFormat())} - {getFormattedDate(filterDate.endDate, DateFormat())}
                    </Box>

                    {(loader) ?
                        <Box sx={{ display: "flex", flexDirection: 'column', gap: 1, justifyContent: 'center', alignItems: 'center', mt: 2 }}>
                            <Skeleton variant='circular' height={"150px"} width={"270px"} sx={{ borderRadius: "175px 175px 0 0", border: "solid #f2f2f2 30px", borderBottom: "none", background: 'transparent' }} >
                                <Skeleton variant='text' height={20} width={200} />
                            </Skeleton>
                            <Skeleton variant='text' height={20} width={200} />
                        </Box> :
                        <>
                            <Box sx={{ display: "flex", flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: 1 }}>
                                <Box sx={{
                                    width: "18.75rem",
                                    height: "175px",
                                    // paddingLeft: '1.5em',
                                }}>
                                    <ReactSpeedometer
                                        fluidWidth={true}
                                        // height={175}
                                        minValue={0}
                                        maxValue={100}
                                        value={environmentRiskScore?.currentScore}
                                        segments={555}
                                        maxSegmentLabels={5}
                                        startColor="#98e565"
                                        endColor="#f44336"
                                        textColor="#000"
                                        needleHeightRatio={0.7}
                                        needleTransitionDuration={4000}
                                        ringWidth={30}
                                        forceRender={true}                                
                                        paddingHorizontal={3}
                                        paddingVertical={3}
                                    />
                                </Box>
                                <Typography variant="body2" color="text.secondary" sx={{ textAlign: "center", mt: 1 }}>
                                    {Math.abs(environmentRiskScore?.prevScore)}% {environmentRiskScore?.prevScore <= 0 ? "increase" : 'drop'} from previous {parseInt(filterType) + 1} days
                                </Typography>
                            </Box>
                            {/* <Typography variant="h1" component="div" className="text-8xl font-bold mb-2">
                                {environmentRiskScore?.currentScore}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                {Math.abs(environmentRiskScore?.prevScore)}% {environmentRiskScore?.prevScore <= 0 ? "increase" : 'drop'} from previous {parseInt(filterType) + 1} days
                            </Typography> */}
                        </>
                    }

                </CardContent>
            </Card>
        </>

    )
}

export default memo(EnvironmentalRiskScore)